export const REPOSITORY_FILTER_KEY = 'report';
export const REPOSITORY_MODULE_KEY = 'reports';
